import { ParticipantLabel } from '@seen/core/models/participantLabel'
import type { ReactNode } from 'react'
import { LabelColor } from '#src/components/LabelColor.tsx'
import { RowBadge, type RowBadgeProps } from '#src/components/TaskRowBadge.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export interface ParticipantLabelBadgeProps extends Omit<
  RowBadgeProps,
  'icon' | 'children'
> {
  label: string | undefined
}

export function ParticipantLabelBadge({
  label: labelReference,
  ...delegated
}: ParticipantLabelBadgeProps): ReactNode {
  const { data: label } = useRead(ParticipantLabel, labelReference)

  if (label?.isDeleted) {
    return null
  }

  return (
    <RowBadge icon={<LabelColor color={label?.color} />} {...delegated}>
      {label?.name}
    </RowBadge>
  )
}
